import { render, staticRenderFns } from "./SearchContext.vue?vue&type=template&id=0b796c6e&"
import script from "./SearchContext.vue?vue&type=script&lang=js&"
export * from "./SearchContext.vue?vue&type=script&lang=js&"
import style0 from "./SearchContext.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports